var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_806_817)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 54C41.8708 54 54 41.8708 54 27C54 12.1292 41.8708 0 27 0C12.1292 0 0 12.1292 0 27C0 41.8708 12.1292 54 27 54Z",
    fill: "#FFE6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.057 14.7348H22.757C22.3459 14.7348 21.9517 14.5715 21.661 14.2808C21.3703 13.9901 21.207 13.5959 21.207 13.1848C21.207 12.7737 21.3703 12.3794 21.661 12.0888C21.9517 11.7981 22.3459 11.6348 22.757 11.6348H32.057C32.4681 11.6348 32.8624 11.7981 33.153 12.0888C33.4437 12.3794 33.607 12.7737 33.607 13.1848C33.607 13.5959 33.4437 13.9901 33.153 14.2808C32.8624 14.5715 32.4681 14.7348 32.057 14.7348Z",
    fill: "#E63946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0586 42.6347H22.7586C21.1143 42.6347 19.5373 41.9815 18.3745 40.8188C17.2118 39.6561 16.5586 38.0791 16.5586 36.4347V17.8347H38.2586V36.4347C38.2586 38.0791 37.6054 39.6561 36.4427 40.8188C35.2799 41.9815 33.7029 42.6347 32.0586 42.6347Z",
    fill: "#E63946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.807 20.9347H15.007C14.5959 20.9347 14.2017 20.7714 13.911 20.4807C13.6203 20.1901 13.457 19.7958 13.457 19.3847C13.457 18.9736 13.6203 18.5794 13.911 18.2887C14.2017 17.998 14.5959 17.8347 15.007 17.8347H39.807C40.2181 17.8347 40.6124 17.998 40.9031 18.2887C41.1937 18.5794 41.357 18.9736 41.357 19.3847C41.357 19.7958 41.1937 20.1901 40.9031 20.4807C40.6124 20.7714 40.2181 20.9347 39.807 20.9347Z",
    fill: "#C9273A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3078 36.4349C23.8967 36.4349 23.5025 36.2716 23.2118 35.9809C22.9211 35.6903 22.7578 35.296 22.7578 34.8849V25.5849C22.7578 25.1738 22.9211 24.7796 23.2118 24.4889C23.5025 24.1982 23.8967 24.0349 24.3078 24.0349C24.7189 24.0349 25.1131 24.1982 25.4038 24.4889C25.6945 24.7796 25.8578 25.1738 25.8578 25.5849V34.8849C25.8578 35.296 25.6945 35.6903 25.4038 35.9809C25.1131 36.2716 24.7189 36.4349 24.3078 36.4349Z",
    fill: "#EDEBEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.507 36.4349C30.0959 36.4349 29.7017 36.2716 29.411 35.9809C29.1203 35.6903 28.957 35.296 28.957 34.8849V25.5849C28.957 25.1738 29.1203 24.7796 29.411 24.4889C29.7017 24.1982 30.0959 24.0349 30.507 24.0349C30.9181 24.0349 31.3124 24.1982 31.603 24.4889C31.8937 24.7796 32.057 25.1738 32.057 25.5849V34.8849C32.057 35.296 31.8937 35.6903 31.603 35.9809C31.3124 36.2716 30.9181 36.4349 30.507 36.4349Z",
    fill: "#EDEBEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_806_817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/red_cross.6d4d5799be1b98836dfac347a274b037.svg";
export { ForwardRef as ReactComponent };